module.exports = __webpack_public_path__ + "img/iriomote_12.38d0d7e1.jpg";